module.exports = __webpack_public_path__ + "media/icons/up-arrow-active-18bd79d0.png";